import { dateFormat } from '../utils'

export default {
  methods: {
    dateFormat (value) {
      return value ? dateFormat(value) : "-";
    }
  }
}
